module.exports = __webpack_public_path__ + "static/media/Nicole Enriquez Headshot_1599237230365.45f2cf75.jpeg";